import { TooltipComponent } from "@syncfusion/ej2-react-popups";
import React, { useEffect, useState } from "react";
import { AiOutlineMenu } from "react-icons/ai";
import { MdKeyboardArrowDown } from "react-icons/md";
import { Cart, Chat, Notification, UserProfile } from ".";
import avatar from "../assets/avatar.avif";
import { useStateContext } from "../contexts/ContextProvider";
import { IoIosPerson } from "react-icons/io";

const NavButton = ({ title, customFunc, icon, color, dotColor }) => (
  <TooltipComponent content={title} position="BottomCenter">
    <button
      type="button"
      onClick={customFunc}
      style={{ color }}
      className="relative text-xl rounded-full p-3 hover:bg-light-gray">
      <span
        style={{ background: dotColor }}
        className="absolute inline-flex rounded-full h-2 w-2 right-2 top-2"
      />
      {icon}
    </button>
  </TooltipComponent>
);

const Navbar = () => {
  const {
    activeMenu,
    setActiveMenu,
    isClicked,
    setIsClicked,
    handleClick,
    screenSize,
    setScreenSize,
    currentColor,
  } = useStateContext();
  const auth = JSON.parse(localStorage.getItem("auth"));

  const [showProfile, setShowProfile] = useState(false);
  useEffect(() => {
    const handleResize = () => setScreenSize(window.innerWidth);

    window.addEventListener("resize", handleResize);

    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (screenSize <= 900) {
      setActiveMenu(false);
    } else {
      setActiveMenu(true);
    }
  }, [screenSize]);

  return (
    <div className="flex justify-between p-2 md:mx-6 relative">
      <div className=" flex space-x-4 ">
        <NavButton
          title="Menu"
          customFunc={() => setActiveMenu((prevActiveMenu) => !prevActiveMenu)}
          color={currentColor}
          icon={<AiOutlineMenu />}
        />
        {/* <select
          className="w-40 rounded-xl bg-primary text-white p-2"
          onChange={(e) => {
            console.log(e.target.value);
            // Handle the selected value here
            // For example, you can set it to a state variable or perform an action
          }}
          name="bureau"
          id="bureau">
          <option value="bamako">Bureau</option>
          <option value="bamako">Bamako</option>
          <option value="kayes">Kayes</option>
          <option value="sikasso">Sikasso</option>
          <option value="mopti">Mopti</option>
        </select> */}
      </div>

      <div className="flex">
        {/* <NavButton
          title="Cart"
          customFunc={() => handleClick('cart')}
          color={currentColor}
          icon={<FiShoppingCart />}
        /> */}

        {/* <NavButton
          title="Chat"
          dotColor="#03C9D7"
          customFunc={() => handleClick("chat")}
          color={currentColor}
          icon={<CiChat2 />}
        />

        <NavButton
          title="Notifications"
          dotColor="#03C9D7"
          customFunc={() => {handleClick("notification")
        }}
          color={currentColor}
          icon={<RiNotification3Line />}
        /> */}

        <TooltipComponent content="Profile" position="BottomCenter">
          <div
            className="flex items-center gap-2 cursor-pointer p-1 hover:bg-light-gray rounded-lg"
            onClick={() => {
              handleClick("userProfile");
              setShowProfile(!showProfile);
            }}>
            <IoIosPerson className="text-3xl text-primary" />

            <p>
              <span className="text-gray-400 font-bold ml-1 text-14">
                {" "}
                {auth?.username}{" "}
              </span>
            </p>
            <MdKeyboardArrowDown className="text-gray-400 text-14" />
          </div>
        </TooltipComponent>

        {isClicked.cart && <Cart />}
        {isClicked.chat && <Chat />}
        {isClicked.notification && <Notification />}
        {isClicked.userProfile && (
          <UserProfile
            showProfile={showProfile}
            setShowProfile={setShowProfile}
          />
        )}
      </div>
    </div>
  );
};

export default Navbar;
